import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: {},
  isAuthenticated: false
}

const {reducer, actions} = createSlice({
  initialState,
  name: 'authentication',
  reducers: {
    update: (state, { payload }) => {
      state.isAuthenticated = true
      state.data = payload
    },
    reset: () => initialState
  },
})

export { actions, reducer }
export default reducer
